import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    "& .MuiOutlinedInput-multiline": {
      padding: 0,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: '#EDEDED',
      top: 0,
      "& legend": {
        display: 'none',
      },
    },
  },
  inputBox: {
    fontSize: 14,
    fontFamily: "inherit",
    padding: '12px 14px',
    // background: '#FAFAFA',
    "&:before": {
      borderBottom: "1px solid rgb(0 0 0 / 0.20)",
    },
  },
  inputLabels: {
    color: "#2E2E2E",
    position: 'static',
    marginBottom: 5,
    lineHeight: '20px',
    fontSize: 14,
    transform: 'none !important',
    fontWeight: 500,
    "&.Mui-focused": {
      color: "#000",
    },
  },
  errorMessages: {
    color: "#F36F6F",
    fontSize: 13,
    marginTop: 3,
    display: "flex",
    "& svg": {
      fontSize: 18,
    },
  },
  formLabel: {
    fontWeight: 500,
    marginBottom: '0.35em',
  }
}));

export default useStyles;
